export const NAV_ITEMS = ["telas", "usos", "características", "dónde comprar"]

export const GLOBAL_SITE_TAG = {
  [process.env.REACT_APP_LATAM_INSTANCE_ID]: "GTM-TZCKW2K"
}
